import AppBar from '@mui/material/AppBar';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';
import { useMatch } from 'react-router-dom';
import ModuleDisplayName from './ModuleDisplayName';
import Logo from 'react/shared/components/Logo';
import theme from 'react/shared/theme/Theme';
import { MODULES } from 'react/signups/card/recipes/constants';
import currentModuleShape from 'react/signups/card/shapes/CurrentModule';
import userTypeShape from 'react/signups/card/shapes/UserType';

const useStyles = makeStyles(() => ({
  appBar: {
    padding: `${theme.spacing(5)} 0 ${theme.spacing(2)}`,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      padding: `${theme.spacing(8)} 0 ${theme.spacing(5)}`,
      width: 'auto',
    },
  },
}));

export default function TopBar({ cardholderFirstName, currentModule, userType }) {
  const classes = useStyles();
  const isSuccessPage = useMatch('/review/success');

  return (
    <AppBar className={classes.appBar} color="transparent" elevation={0} position="static">
      {currentModule === MODULES.SURVEY || (currentModule === MODULES.REVIEW && isSuccessPage) ? (
        <div>
          <Logo />
        </div>
      ) : (
        <ModuleDisplayName
          cardholderFirstName={cardholderFirstName}
          currentModule={currentModule}
          userType={userType}
        />
      )}
    </AppBar>
  );
}

TopBar.propTypes = {
  cardholderFirstName: PropTypes.string,
  currentModule: currentModuleShape.isRequired,
  userType: userTypeShape,
};
